import React from 'react'
import {
    Dropdown,
    DropdownTrigger,
    DropdownMenu,
    DropdownSection,
    DropdownItem
  } from "@nextui-org/dropdown";
  import { Button } from '@nextui-org/react';
import Typography from './Typography';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import theme from '../../theme';
import { signOut } from '../../../service/common/firebase';
import { useNavigate } from 'react-router';
  

export default function UserCardDropdown() {

    const navigate = useNavigate();

  return (
    <Dropdown>
        <DropdownTrigger>
            <Button isIconOnly className='bg-transparent' >
                <MoreVertIcon style={{color: 'black', fontSize: theme.sizing.x3}} />
            </Button>
        </DropdownTrigger>
        <DropdownMenu  aria-label="Static Actions">
            <DropdownItem onPress={()=>navigate("/settings")} key="1">
                <Typography
                variant="button"
                colorVariant="text"
                style={{fontWeight: 600}}
                >
                Impostazioni 
                </Typography>
            </DropdownItem>
            <DropdownItem key="2"
                onPress={() => window.open('https://www.iubenda.com/termini-e-condizioni/15049131')?.focus()}>
                <Typography
                    variant="button"
                    colorVariant="text"
                    style={{fontWeight: 600}}
                    >
                    Termini e Condizioni
                </Typography>
            </DropdownItem>
            <DropdownItem key="3"
                onPress={() => window.open('https://www.iubenda.com/privacy-policy/31147474')?.focus()}>
                <Typography
                    variant="button"
                    colorVariant="text"
                    style={{fontWeight: 600}}
                    >
                    Privacy Policy
                </Typography>
            </DropdownItem>
            <DropdownItem key="4"
                onPress={() => window.open('https://www.iubenda.com/privacy-policy/31147474/cookie-policy')?.focus()}>
                <Typography
                    variant="button"
                    colorVariant="text"
                    style={{fontWeight: 600}}
                    >
                    Cookies Policy
                </Typography>
            </DropdownItem>
            <DropdownItem onPress={signOut} key="5">
                <Typography
                    variant="button"
                    colorVariant="text"
                    style={{fontWeight: 600}}
                    >
                    Logout
                </Typography>
            </DropdownItem>
        </DropdownMenu>
    </Dropdown>
  )
}
